import type { ApproBffSDK } from '@invivodf/module-appro-bff-sdk'
import { useAuthService } from '@b2ag/auth'
import { buildCallerId } from '@b2ag/utils/src/caller-id'
import { createBffSdk } from '@b2ag/utils/src/esmParser'
import type { SearchDynamicSegmentsParameters } from '@invivodf/module-appro-bff-sdk/src/entrypoints/segments/search-dynamic-segments/search-dynamic-segments'

export type SegmentsServiceParams = { segmentsApiHost: string }

class SegmentsService {
  private readonly sdk: ApproBffSDK

  constructor({ segmentsApiHost }: SegmentsServiceParams) {
    const accessTokenSource = async () => useAuthService().getAccessToken()
    this.sdk = createBffSdk(segmentsApiHost, { callerId: buildCallerId(), accessTokenSource })
  }

  fetchDynamicSegments({ partnerId, customerCode, requests }: SearchDynamicSegmentsParameters) {
    return this.sdk.searchDynamicSegments({ partnerId, customerCode, requests })
  }
}

export default SegmentsService
